module.exports = __webpack_public_path__ + "img/logo-abalon-fa.51d2421.png";